




































































































































































































































































































































































































































































































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import PointerMenu from "../general/PointerMenu.vue";
import ExpandableView from "../controls/ExpandableView.vue";
import Loading from "../general/Loading.vue";
import OverlayPictureViewer from "../general/OverlayPictureViewer.vue";

import RentalBookingJson, {
  defaultRentalBookingJson,
  getRentalBookingTotalPrice,
} from "../../shared/RentalBookingJson";
import { RentalBookingStatus, RentalBookingStatusNames } from "../../shared/RentalBookingStatus";
import RentalConditionJson, { getRentalConditionPrice } from "../../shared/RentalConditionJson";
import CustomerJson from "../../shared/CustomerJson";
import SepaMandateJson from "../../shared/SepaMandateJson";
import PriceUtils from "../../shared/PriceUtils";
import { Gender } from "../../shared/Gender";

import SettingsJson from "../../shared/SettingsJson";
import { UserPermissionRank } from "../../shared/UserPermissionRank";

import { ValidationResult, Validation } from "../../shared/Validation";
import { validateRentalBookingJson, validateRentalBookingJsonAdd } from "../../shared/RentalBookingJson";

import RentalBookingPeriodSelect from "./RentalBookingPeriodSelect.vue";
import RentalBookingAdditionalConditionSelect from "./RentalBookingAdditionalConditionSelect.vue";
import RentalTimeSlotJson from "../../shared/RentalTimeSlotJson";
import FormCustomer from "../general/FormCustomer.vue";
import FormSepaMandate from "../general/FormSepaMandate.vue";
import InvoiceInfoDetails from "../general/InvoiceInfoDetails.vue";
import ImageSelectBase64 from "../general/ImageSelectBase64.vue";

export default Vue.extend({
  name: "RentalBookingDetails",
  components: {
    OverlayWindow,
    PointerMenu,
    ExpandableView,
    Loading,
    RentalBookingPeriodSelect,
    RentalBookingAdditionalConditionSelect,
    FormCustomer,
    FormSepaMandate,
    InvoiceInfoDetails,
    ImageSelectBase64,
    OverlayPictureViewer,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    bookingId: Number,
    mode: String,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      Gender: Gender,
      RentalBookingDefaultData: defaultRentalBookingJson(),
      RentalBookingStatus: RentalBookingStatus,
      RentalBookingStatusNames: RentalBookingStatusNames,
      PriceUtils: PriceUtils,
      supportsDatePicker: false,
      editable: false as boolean,
      detailsTitle: "",
      UserPermissionRank: UserPermissionRank,
      detailsMode: "",
      selectedBookingId: null as number | null,
      details: null as RentalBookingJson | null,
      rentalBookingTotalPrice: { priceIncludingVAT: 0, priceExcludingVAT: 0 } as {
        priceIncludingVAT: number;
        priceExcludingVAT: number;
      },
      overlayPictureViewerImgUrl: null as string | null,
      useSepaMandate: false as boolean,
      pickupSlots: null as RentalTimeSlotJson[] | null,
      returnSlots: null as RentalTimeSlotJson[] | null,
      hasChanges: false,
      hintChanged: {
        state: false as boolean,
      },
      toValidate: {} as any,
      validation: null as ValidationResult<RentalBookingJson> | null,
      submitValidation: false as boolean,
      loadingGeneral: false as boolean,
      loadingNextup: false as boolean,
    };
  },
  created() {
    this.initDetails();
  },
  mounted() {
    this.checkDatePickerSupport();
  },
  methods: {
    initDetails() {
      this.selectedBookingId = this.bookingId;
      this.loadDetails();

      this.selectDetailsMode(this.mode);
    },

    setCachedData() {
      this.$nextTick(() => {
        this.hasChanges = false;
      });
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    async loadDetails() {
      if (this.selectedBookingId != null) {
        if (this.restClient != null) {
          try {
            this.details = await this.restClient.getRentalBooking(this.selectedBookingId);

            if (this.details.sepaMandate != null) {
              this.useSepaMandate = true;
            }
          } catch (e) {
            alert(e.message);
          }
        }
      } else {
        this.details = { ...this.RentalBookingDefaultData };
      }

      this.setCachedData();
      this.calcRentalBookingTotalPrice();
      this.hasChanges = false;
    },

    getDefaultSepaMandate(): SepaMandateJson {
      return {
        ID: null,
        dateTime: new Date().toISOString(),
        lastUseDateTime: new Date().toISOString(),
        accountHolderFirstName: this.details && this.details.customer ? this.details.customer.guardianFirstName : "",
        accountHolderLastName: this.details && this.details.customer ? this.details.customer.guardianLastName : "",
        addressStreet: this.details && this.details.customer ? this.details.customer.addressStreet : "",
        addressZip: this.details && this.details.customer ? this.details.customer.addressZip : "",
        addressCity: this.details && this.details.customer ? this.details.customer.addressCity : "",
        addressCountry: this.details && this.details.customer ? this.details.customer.addressCountry : "",
        IBAN: "",
        BIC: "",
      };
    },

    //START set cached data

    //END set cached data

    selectDetailsMode(mode: string) {
      this.resetHintChanged();

      switch (mode) {
        case "add":
          this.detailsMode = "add";
          this.detailsTitle = "Buchung hinzufügen";
          this.editable = true;
          break;

        case "edit":
          this.detailsMode = "edit";
          this.detailsTitle = "Buchung bearbeiten";
          this.editable = true;
          break;

        default:
          this.detailsMode = "read";
          this.detailsTitle = "Buchung";
          this.editable = false;
          break;
      }

      this.loadPickupSlots();
      this.loadReturnSlots();
    },

    toggleEditMode() {
      this.editable = !this.editable;

      this.loadPickupSlots();
      this.loadReturnSlots();
    },

    resetHintChanged() {
      let k = this.hintChanged;
      let i: keyof typeof k;

      for (i in this.hintChanged) {
        this.hintChanged[i] = false;
      }
    },

    stopEditMode() {
      if (!this.hasChanges) {
        //todo: use $refs
        document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
        this.selectDetailsMode("show");
        this.hasChanges = false;
        this.loadDetails();
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
          this.selectDetailsMode("show");
          this.hasChanges = false;
          this.loadDetails();
        } else {
          //do nothing
        }
      }
    },

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("closeOverlay");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("closeOverlay");
        } else {
          //do nothing
        }
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.details != null) {
        this.validation = validateRentalBookingJson(this.details);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    async loadPickupSlots() {
      if(this.editable && this.settings.rentalRequestPickupAndReturnTime && this.details) {
        if(this.details.beginDate) {
          let weekDay = DateFormatter.parseISODate(this.details.beginDate)?.getDay();
          
          if(weekDay) {
            this.pickupSlots = null;

            let rc = RestClient;
            try {
              this.pickupSlots = await rc.getRentalPickupReturnSlots(weekDay);
              this.$forceUpdate();
            } catch (e) {
              alert(e.message);
            }
          }
        }
      }
    },

    async loadReturnSlots() {
      if(this.editable && this.settings.rentalRequestPickupAndReturnTime && this.details) {
        if(this.details.endDate) {
          let weekDay = DateFormatter.parseISODate(this.details.endDate)?.getDay();
          
          if(weekDay) {
            this.returnSlots = null;

            let rc = RestClient;
            try {
              this.returnSlots = await rc.getRentalPickupReturnSlots(weekDay);

              if(this.returnSlots != null && this.returnSlots.length <= 0) {
                if(this.details.rentalItem?.contactlessReturn) {
                  this.returnSlots = [{ "beginTime": "00:00", "endTime": "23:59" }];
                }
              }
              this.$forceUpdate();
            } catch (e) {
              alert(e.message);
            }
          }
        }
      }
    },

    calcRentalBookingTotalPrice() {
      if (this.details != null) {
        this.rentalBookingTotalPrice = getRentalBookingTotalPrice(this.details);
      }
    },

    toggleUseSepaMandate() {
      if (this.details != null) {
        if (this.useSepaMandate) {
          this.details.sepaMandate = this.getDefaultSepaMandate();
        } else {
          this.details.sepaMandate = null;
        }
      }
    },

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    async saveBooking() {
      if (this.hasChanges) {
        if (await this.saveBookingDetails()) {
          //this.stopEditMode();
          this.closeDetails();
        }
      } else {
        alert("Es wurden keine Änderungen vorgenommen.");
      }
    },

    async saveBookingDetails() {
      if (this.details != null) {
        this.loadingGeneral = true;
        this.submitValidation = true;

        //set cancellationDateTime
        if (
          this.details.state == RentalBookingStatus.cancellationPending ||
          this.details.state == RentalBookingStatus.canceled ||
          this.details.state == RentalBookingStatus.cancellationFeeExported ||
          this.details.state == RentalBookingStatus.cancellationFeeReceived
        ) {
          this.details.cancellationDateTime = new Date().toISOString();
        } else {
          this.details.cancellationDateTime = null;
        }

        //todo ###START
        //todo: Validation muss durchgeführt werden (siehe hier) ->AUCH bei SettingsDetails
        this.validation = validateRentalBookingJson(this.details);
        //todo ###END

        if (this.validation != null && this.validation.isValid == true) {
          if (this.restClient != null) {
            try {
              let updatedDetails = await this.restClient.updateRentalBooking(this.details);

              this.hasChanges = false;
              this.loadingGeneral = false;
              this.submitValidation = false;
              //this.stopEditMode();

              //TODO: Validation error loest alert auch aus -> prüfen
              alert("Die Änderungen wurden erfolgreich gespeichert.");

              return true;
            } catch (e) {
              this.loadingGeneral = false;
              alert(e.message);

              return false;
            }
          }
        } else {
          this.loadingGeneral = false;
          alert("Die Änderungen konnten nicht gespeichert werden. Bitte überprüfen Sie Ihre Änderungen.");

          return false;
        }
      }
    },

    async deleteBooking() {
      if (this.selectedBookingId != null) {
        let c = confirm("Wollen Sie diese Buchung wirklich unwiderruflich löschen?");
        if (c == true) {
          if (this.restClient != null) {
            try {
              await this.restClient.deleteRentalBooking(this.selectedBookingId);
              this.closeDetails();
              alert("Die Buchung wurde erfolgreich gelöscht.");
            } catch (e) {
              alert(e.message);
            }
          }
        } else {
          //do nothing
        }
      }
    },

    async sendBookingConfirmation() {
      this.loadingNextup = true;

      if (this.hasChanges) {
        if (!(await this.saveBookingDetails())) {
          return false;
        }
      }

      if (this.selectedBookingId != null && this.restClient != null) {
        try {
          await this.restClient.confirmRentalBooking(this.selectedBookingId);
          alert("Die Buchung wurde angenommen.");
          this.hasChanges = false;
          this.stopEditMode();
          this.loadingNextup = false;
        } catch (e) {
          alert(e.message);
          this.loadingNextup = false;
        }
      }
    },

    async markAsCollected() {
      this.loadingNextup = true;

      if (this.hasChanges) {
        if (!(await this.saveBookingDetails())) {
          return false;
        }
      }

      if (this.selectedBookingId != null && this.restClient != null) {
        try {
          await this.restClient.setRentalBookingCollected(this.selectedBookingId);
          alert("Die Buchung wurde als abgeholt markiert.");
          this.hasChanges = false;
          this.stopEditMode();
          this.loadingNextup = false;
        } catch (e) {
          alert(e.message);
          this.loadingNextup = false;
        }
      }
    },

    async markAsReturned() {
      this.loadingNextup = true;

      if (this.hasChanges) {
        if (!(await this.saveBookingDetails())) {
          return false;
        }
      }

      if (this.selectedBookingId != null && this.restClient != null) {
        try {
          await this.restClient.setRentalBookingReturned(this.selectedBookingId);
          alert("Die Buchung wurde als zurückgegeben markiert.");
          this.hasChanges = false;
          this.stopEditMode();
          this.loadingNextup = false;
        } catch (e) {
          alert(e.message);
          this.loadingNextup = false;
        }
      }
    },

    async cancelBooking() {
      if (!this.hasChanges) {
        if (this.details != null) {
          let c = confirm(
            "Wollen Sie die Absage per E-Mail bestätigen? Die Anfrage/Buchung wird unter Berücksichtigung der Stornierungsgebühr (€ " +
              this.getFormatPrice(this.details.rentalCondition.cancellationFee) +
              ") abgesagt."
          );
          if (c == true) {
            this.loadingGeneral = true;

            if (this.selectedBookingId != null && this.restClient != null) {
              try {
                await this.restClient.cancelRentalBooking(this.selectedBookingId);
                this.closeDetails();
                alert("Die Anfrage/Buchung wurde erfolgreich abgesagt.");

                this.loadingGeneral = false;
              } catch (e) {
                alert(e.message);

                this.loadingGeneral = false;
              }
            }
          } else {
            //do nothing
          }
        }
      } else {
        alert("Bitte speichern Sie zuvor die letzten Änderungen.");
      }
    },

    async readyForPayment() {
      this.loadingNextup = true;

      if (this.hasChanges) {
        if (!(await this.saveBookingDetails())) {
          return false;
        }
      }

      if (this.selectedBookingId != null && this.restClient != null) {
        try {
          await this.restClient.setRentalBookingReadyForPayment(this.selectedBookingId);
          alert("Die Buchung wurde als „Bereit für Bezahlung“ markiert.");
          this.hasChanges = false;
          this.stopEditMode();
          this.loadingNextup = false;
        } catch (e) {
          alert(e.message);
          this.loadingNextup = false;
        }
      }
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    details: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
          this.calcRentalBookingTotalPrice();
        }
      },
      deep: true,
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },
  },
});
